import { InputMask } from 'imask'

export const PhoneNumberMask = {
  mask: null,
  mounted() {
    const maskOptions = {
      mask: '+{1} (000) 000-0000',
    }
    this.mask = new InputMask(this.el, maskOptions)
  },
  destroyed() {
    this.mask.destroy()
  },
}
